import BaseService from "../../services/BaseService";
import { convertLivestockToLote, validateLivestockResponse } from "./loteUtils";

const URL_BASE_LIVESTOCK = `${process.env.REACT_APP_ENDPOINT}herds/livestock`;

/**
 * @deprecated in favor of typescript service: livestockServiceMixin.ts
 * - the remaining method is already migrated (listLivestockFromFarm) but kept here for consistency
 * of the response conversion to Lote model
 * - when `listaLotesPasto` operation is migrated, remove this class too
 */
export class LoteService extends BaseService {
  async listaLotesPasto(idFazenda) {
    try {
      const urlServico = `${URL_BASE_LIVESTOCK}/from-farm/${idFazenda}`;
      const response = await this.get(urlServico);

      return validateLivestockResponse(response, (response) => ({
        ...response,
        data: convertLivestockToLote(response.data.data),
      }));
    } catch (erro) {
      return {
        erro,
      };
    }
  }
}

export default new LoteService();
